import React, { useContext } from 'react';

interface IntentContextProps {
  isHistory: boolean;
  historySessionId?: string;
  sessionId: string;
  historyDialogueId?: string;
  dialogueId: string;
  nodePointId: string;
}

export const IntentContextStore = React.createContext<IntentContextProps>({} as IntentContextProps);
